<script>


export default {
    name: 'StockGroupId',
    props:[
        "list",
        "data",
        "to"
    ],
    data() {
      return {
        stockList : [],
      };
    },
    watch:{
        data(){ 
           this.stockList= []
           this.getStockList() 
        }
    }, 
    methods: {
        latestMovement(stck, name){
            const movement = stck.latest_movement
            if (!movement) return ''
            if (name === 'name') return movement.created_by?.name ?? ''
            return movement[name] ?? ''
        },  

        getStockList() {
            let url = `/transmitter/stocks/${this.list}?group=true`

            if(this.to == 'verici'){
                 url = `/transmitter/stocks/${this.list}`
            }

            this.$http.post(url, this.serverParams)
            .then(response => this.stockList = response.data)
        },
        anadepoya(prop) {
            this.$http.post('/stock/depo/transfer', {
                basket: [{ id: prop.id, amount: prop.amount }],
                returnToDepot: true
            })
            .then(resp => {
                if (resp.data.error) return
                this.stockList = []
                this.getStockList()
            })
        },
        close(){  this.$parent.$bvModal.hide('stoklar-modal-scoped') },
    },
};
</script>
<template>
  <b-modal id="stoklar-modal-scoped" title="Stoklar"  no-close-on-backdrop hide-footer size="lg">
      <form @submit.prevent="handleSubmit">
        <div class="row mb-1">
            <div class="col-md-12">
                <table class="table table-sm">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Cihaz</th>
                            <th>Barkod</th>
                            <th>Adet</th>
                            <th>Eklendiği Tarih</th>
                            <th>Kimin Stoğundan</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(stck, i) in stockList" :key="`stockid${i}`">
                            <td class="align-middle">{{  i+1 }}</td>
                            <td class="align-middle">{{  stck.stock_group_name }}</td>
                            <td class="align-middle">{{  stck.name }}</td>
                            <td class="align-middle">{{  stck.amount }}</td>
                            <td class="align-middle">{{  latestMovement(stck, 'created_at') }}</td>
                            <td class="align-middle">{{  latestMovement(stck, 'name') }}</td>
                            <td class="width-50"><button @click="anadepoya(stck)" class="btn btn-danger btn-sm">X</button></td>
                        </tr>
                    </tbody>
                </table>
          </div>
        </div>
      
        <div class="d-flex justify-content-between mt-3">
            <div>
                <b-button variant="light" @click="close()">Kapat</b-button>
            </div>
        </div>
    </form>
  </b-modal>
</template>